import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { AvatarVO } from "./AvatarVO";

export class SocialBuddyVO extends AvatarVO {
    public thumbUrl: string = "";

    constructor() {
        super();
    }
}
classImplementsInterfaces(SocialBuddyVO, "IInventoryVO");
